import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getSurveyResult1 } from '../../../api/surveyQuestion.api';
import useAxios from '../../../hooks/useAxios';
import { getCommonCodeLabel } from '../../../lib/store';
import {
  IGetSurveyResult1,
  ISurveyResultParams,
} from '../../../models/surveyQuestion.model';
import { RootState } from '../../../store/rootReducer';
import ErrorResponse from '../../ErrorResponse';
import Loader from '../../Loader';
import ResultSearchBar from './ResultSearchBar';

interface IProps {
  surveyCode: number | undefined;
}

const SurveyResult1: FC<IProps> = ({ surveyCode }) => {
  const { t } = useTranslation();
  const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetSurveyResult1>();

  const [campusCode, setCampusCode] = useState('');
  const [courseCode, setCourseCode] = useState('');

  useEffect(() => {
    if (surveyCode) {
      doGetSurveyResult1();
    }
  }, [surveyCode]);

  const doGetSurveyResult1 = () => {
    if (!surveyCode) return;

    const req: ISurveyResultParams = {};
    if (auth.hqYn === 'Y') {
      if (campusCode) req.campusCode = campusCode;
    } else {
      req.campusCode = currentCampus;
    }
    if (courseCode) req.courseCode = courseCode;

    execute(getSurveyResult1(surveyCode, req));
  };

  const onSearch = () => {
    doGetSurveyResult1();
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <div>
        <div className="comm-bx__between">
          <div />
          <ResultSearchBar
            campusCode={campusCode}
            setCampusCode={setCampusCode}
            courseCode={courseCode}
            setCourseCode={setCourseCode}
            onSearch={onSearch}
          />
        </div>
        <div className="comm-table__area">
          <table>
            <thead>
              <tr>
                <th className="text-center">{t('common.column.category')}</th>
                <th className="text-center">{t('homepage.survey.column8')}</th>
              </tr>
            </thead>
            <tbody>
              
              {res?.data?.map((item, index) => (
                <tr key={index}>
                  <td className="text-center">
                    {getCommonCodeLabel('HP0007', item.surveyCategory, 'ko')}
                  </td>
                  <td className="text-center">{item.score.toFixed(1)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default SurveyResult1;
